// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1APMi","title":"styles_title__1Qsex"};